import React from 'react';
import { screenSmMin, screenXsMax } from '@spotify-internal/encore-foundation';
import styled from 'styled-components';
import { useEncoreContextType } from "../../hooks/useEncoreContextType";
import { finale, typeStyleBody2, typeStyleBody3 } from "../../styles";
import { Type } from "../Type";
export var Copyright = styled(function (props) {
  return /*#__PURE__*/React.createElement(Type, Object.assign({
    as: "small"
  }, props));
}).withConfig({
  displayName: "Copyright",
  componentId: "sc-15d7gge-0"
})(["padding-block-end:0;flex-shrink:0;", ";@media (max-width:", "){", ";}@media (min-width:", "){", ";}"], function () {
  return useEncoreContextType(undefined, finale());
}, screenXsMax, function () {
  return useEncoreContextType(typeStyleBody2(), undefined);
}, screenSmMin, function () {
  return useEncoreContextType(typeStyleBody3(), undefined);
});
export default Copyright;